function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMccAirlines = function SvgMccAirlines(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12.352 3.268A1 1 0 0 1 13.316 2h4.066a1 1 0 0 1 .894.553L25 16h10a3 3 0 0 1 0 6H25l-6.724 13.447a1 1 0 0 1-.894.553h-4.066a1 1 0 0 1-.964-1.268L15.89 22H9.667l-1.439 4.316a1 1 0 0 1-.949.684H3.387a1 1 0 0 1-.948-1.316L4.667 19l-2.228-6.684A1 1 0 0 1 3.387 11H7.28a1 1 0 0 1 .949.684L9.667 16h6.222L12.352 3.268Z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgMccAirlines;